import React, { FC } from 'react';
import { IconButton, IconButtonProps, useTheme } from '@mui/material';

type GradientIconButton = IconButtonProps;
const GradientIconButton: FC<GradientIconButton> = ({ children, sx, ...props }) => {
    const theme = useTheme();
    const bg = 'linear-gradient(85.83deg, #FBF7F6 1.91%, #F4FCFC 99.17%)';
    return (
        <IconButton {...props} sx={{ background: bg, borderRadius: 1, color: theme.palette.primary.main, ...sx }}>
            {children}
        </IconButton>
    );
};
export default GradientIconButton;
